
<div
  v-if="!term"
  class="c-search-highlights-content"
>
  <template v-if="latestSearchedTerms.length || isDesktop">
    <SearchTags
      title="buscas recentes"
      class="c-search-highlights-content__recent-terms"
      :cards="latestSearchedTerms"
      @choose-term="useTerm"
    >
      nenhuma<br> busca recente
    </SearchTags>
  </template>

  <div
    v-if="isFetchingSearchHihglights"
    class="c-search-highlights-sections"
  >
    <SearchTags
      :cards="searchTagsPlaceholder"
      class="c-search-highlights-section"
      is-loading
    />

    <SearchCards
      v-for="(section, index) in ['enjoei pro', 'lojas famosas']"
      :key="`placeholder-${index}`"
      class="c-search-highlights-section__cards"
      :title="section"
      :is-fetching="isFetchingSearchHihglights"
    />
  </div>

  <div
    v-else-if="searchHighlightsSections.length"
    class="c-search-highlights-sections"
  >
    <div
      v-for="(section, sectionIndex) in searchHighlightsSections"
      :key="`search-section-${sectionIndex}`"
      class="c-search-highlights-section"
    >
      <component
        :is="section.layout.name"
        v-for="(component, componentIndex) in section.components"
        :key="`search-component-${componentIndex}`"
        :title="component.title"
        :action="component.action"
        :cards="component.cards"
        :card-radius="section.layout['card-radius']"
        @choose-term="navigateToUrl"
      />
    </div>
  </div>
</div>
<div v-else>
  <ContextSelector
    :selected-context="selectedContext"
    @change-context="onContextChange"
  />

  <SearchSuggestions
    :term="term"
    :context="selectedContext"
    @choose-term="useTerm"
  />
</div>
